var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "echarts-dom",
    style: _vm.chartStyle,
    attrs: { id: _vm.chartId },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }